export default function RegisterLayout({ children, showSuccess }) {
  return (
    <div className="dr-register-wrapper">
      {/* LEFT */}
      <div className="dr-register-left">
  <div className="dr-logo-box">
    <img src="/logo.png" alt="Suryojasvi Logo" className="dr-logo" />
    <p className="dr-logo-text">BRIGHT VISION</p>
  </div>
</div>


      {/* RIGHT */}
      <div className="dr-register-right">
        <div className="dr-register-card">{children}</div>
      </div>

      {showSuccess && (
        <div className="dr-success-popup">
          <div className="dr-success-inner">
            <div className="dr-success-icon">✓</div>
            <div className="dr-success-msg">Registered Successfully</div>
          </div>
        </div>
      )}
    </div>
  );
}
